import { Col, Row, Typography } from "antd";
import HpIcon, { Icons } from "react-hp-icons";
import React from "react";

export const IconText = ({ value, iconType }) => {
	const noInfo = "Sin información";
	const size = 14;
	return (
		<Row gutter={10} style={{ fontSize: size }}>
			<Col>
				<HpIcon
					type={Icons[iconType]}
					size={Math.round(size / 10)}
				></HpIcon>
			</Col>
			<Col>
				{/* <Typography.Paragraph
					ellipsis={{ rows: 1, expandable: true, symbol: "ver más" }}
				> */}
				<p>{value || noInfo}</p>
				{/* </Typography.Paragraph> */}
			</Col>
		</Row>
	);
};
